









































import { IFormSection, IFormTemplate } from '@/models';

import FormBuilderGeneralTab from './tabs/FormBuilderGeneralTab.vue';
import FormBuilderOptionTab from './tabs/FormBuilderOptionTab.vue';
import FormBuilderConstraintsTab from './tabs/FormBuilderConstraintsTab.vue';

import Vue, { PropType } from 'vue';
import Proxyable from '@/mixins/proxyable';

export enum PropertyTabs {
  General,
  Option,
  Constraint
}

export default Proxyable.extend({
  components: {
    FormBuilderGeneralTab,
    FormBuilderOptionTab,
    FormBuilderConstraintsTab
  },

  props: {
    template: Object as PropType<IFormTemplate>,
    section: Object as PropType<IFormSection>,
    selectedFieldIndex: {
      type: Number,
      required: false
    },
    drawer: Boolean
  },

  data() {
    return {
      PropertyTabs,
      tab: PropertyTabs.General
    };
  },

  computed: {
    localFieldSection: {
      get(): IFormSection {
        return this.section;
      },
      set(value: IFormSection) {
        this.$emit('update:section', value);
      }
    }
  },

  methods: {
    save() {
      this.$emit('save');
    },

    close() {
      this.internalValue = false;
    },

    goToTabWindow(tab: PropertyTabs) {
      this.tab = tab;
    }
  }
});
